import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';

type NoteModalProps = ComponentProps<typeof Modal>;

const StyledModal = styled(Modal)`
  .ant-modal-body {
    height: max(50vh, 400px);
    overflow-y: auto;
  }
`;

const cancelButtonProps: NoteModalProps['cancelButtonProps'] = { style: { display: 'none' } };

export const NoteModal = (props: NoteModalProps) => <StyledModal cancelButtonProps={cancelButtonProps} {...props} />;
